/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  intro: {
    title: 'Ciao {{name}}',
    introduction:
      'Pronto(a) a iniziare la tua sessione di esercizi? Concentrati sulle contrazioni muscolari e cerca di sentirle, anche se non vedi nulla muoversi. Lascia il resto del viso a riposo.',
    instruction: 'Fai gli esercizi lentamente seguendo il ritmo proposto.',
  },
  permission: {
    title: 'Permessi',
    introduction:
      'Per poter continuare la tua sessione, devi consentire l’accesso di questa pagina Web alla tua fotocamera e al tuo microfono.',
    instruction:
      'Per accedere alla tua sessione, dovrai prima autorizzarla modificando le impostazioni del tuo browser.',
  },
};
